import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { I_POP_OVER, SUPPORTED_PAYMENT_METHOD } from "../../constants";
import Currency from "../currency";
import CurrencyFormat from "../currencyFormat/currencyFormat";
import { useNavigate } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import InfoModalStatic from "../../pages/dashboard/infoModalStatic";

export default function PaymentStatus() {
  const [infoModalStaicShow, setInfoModalStaticShow] = useState(false);
  const [infoModalStaicShowType, setInfoModalStaticShowType] = useState(null);
  const { paymentResponse, cartAmount, paymentBankModalMessage, paymentType } = useSelector(state => state.stripe)
  const handleClickInfo = type => {
    setInfoModalStaticShow(true);
    setInfoModalStaticShowType(type);
  };
  return (
    <>
      <div className="container">
        <div className="row buyProductSectionBg">
          <div className="col-md-12">
            {
              paymentType === 1 ?
                <div className="paymentStatusSection paidPayment">
                  <img src="assets/img/check-circle.svg" alt="" />
                  <p className="m-0 paymentStatusText paidPaymentText">Paid</p>
                </div>
                : paymentType === 2 ?
                  <div className="paymentStatusSection inProgressPayment">
                    <img src="assets/img/info-circle.svg" alt="" />
                    <p className="m-0 paymentStatusText inProgressText">In-process</p>
                  </div>
                  :
                  <div className="paymentStatusSection failedPayment">
                    <img src="assets/img/x-circle.svg" alt="" />
                    <p className="m-0 paymentStatusText failedText">Failed</p>
                  </div>
            }



            <div className="transferAmount">
              <p className="m-0">Your transfer</p>
              <h5 className="m-0">
                <Currency currency={paymentResponse?.currency || ''} />
                <CurrencyFormat
                  currency={paymentResponse?.currency}
                  value={parseFloat(paymentResponse?.amount / 100)}
                  decimal={2}
                />
              </h5>
            </div>

            <div className="paymentPersonName">
              <p className="m-0">{paymentBankModalMessage}</p>
            </div>

            <div className="imageicon">
              <img src="assets/img/bankImage.svg" alt="" />
            </div>


            <div className="followingSection">
              <div className="followingAmountAlign">
                <div>
                  <p className="m-0 detailsAmountText">Price</p>
                </div>
                <div className="detailsAmountText detailsAmountTextFlex">
                  <div className="detailsPriceText me-1">
                    <Currency
                      currency={paymentResponse?.currency || ""}
                    />
                    <CurrencyFormat
                      currency={paymentResponse?.currency}
                      value={parseFloat(paymentResponse?.baseAmount / 100)}
                      decimal={2}
                    />
                  </div> {paymentResponse?.quantity && <div className="detailsAmountText">x {paymentResponse?.quantity?.value} qty</div>}
                </div>
              </div>

              <div className="followingAmountAlign">
                <div className="followingicon detailsAmountText">
                  Amount
                  <div
                    onClick={() =>
                      handleClickInfo(
                        paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                          ? I_POP_OVER.BANK_TRANSFER_SENDING_AMOUNT
                          : paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                            ? I_POP_OVER.CRYPTO_TRANSFER_SENDING_AMOUNT
                            : paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                              ? I_POP_OVER.STRIPE_AMOUNT
                              : null
                      )
                    }
                  >
                    <img className="infoIconImage" src="assets/img/InfoIcon.png" alt="info" />
                  </div>
                </div>
                <div className="detailsAmountText detailsPriceText">
                  <Currency currency={paymentResponse?.currency || ''} />
                  <CurrencyFormat
                    currency={paymentResponse?.currency}
                    value={parseFloat(paymentResponse?.baseAmount / 100)}
                    decimal={2}
                  />
                </div>
              </div>

              <div className="followingAmountAlign">
                <div className="followingicon detailsAmountText">
                  {`Transaction fee ${(paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER || paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO) ? "" : `(${cartAmount?.charges}%)`}`}
                  <div
                    onClick={() =>
                      handleClickInfo(
                        paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                          ? I_POP_OVER.BANK_TRANSFER_SENDING_AMOUNT
                          : paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                            ? I_POP_OVER.CRYPTO_TRANSFER_SENDING_AMOUNT
                            : paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                              ? I_POP_OVER.STRIPE_TRANSACTION_FEES
                              : null
                      )
                    }
                  >
                    <img src="assets/img/InfoIcon.png" className="infoIconImage" alt="info" />
                  </div>
                </div>
                {paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO || paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ?
                  <div className="detailsAmountText">Included</div>
                  :
                  <div className="detailsAmountText detailsPriceText">
                    <Currency currency={paymentResponse?.currency || ''} />
                    <CurrencyFormat
                      currency={paymentResponse?.currency}
                      value={parseFloat(paymentResponse?.transactionFee / 100)}
                      decimal={2}
                    />
                  </div>
                }
              </div>
              <hr
                className="dootedHrLine"
                style={{ marginBottom: "8px", marginTop: "0px" }}
              />
              <div className="followingAmountAlign">
                <div>
                  <p className="m-0 detailsTotslAmountText">Total</p>
                </div>
                <div className="detailsTotslAmountText detailsPriceText">
                  <Currency currency={paymentResponse?.currency || ''} />
                  <CurrencyFormat
                    currency={paymentResponse?.currency}
                    value={parseFloat(paymentResponse?.amount / 100)}
                    decimal={2}
                  />
                </div>
              </div>
            </div>
            {paymentResponse?.paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER &&
              <div className="userAccountDetails">
                <p className="m-0">{paymentResponse?.nickName + "'s" || "-"} account details</p>
                <hr style={{ margin: "12px 0px", border: "1px dashed #000", background: 'transparent' }} />
                <div className="userAccountDetailsInner">
                  <p className="m-0">IBAN</p>
                  <p className="m-0">{paymentResponse?.number || "-"}</p>
                </div>
                <div className="userAccountDetailsInner">
                  <p className="m-0">BIC</p>
                  <p className="m-0"> {paymentResponse?.sendingInstruction || "-"}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <InfoModalStatic
        infoModalStaticShow={infoModalStaicShow}
        infoModalStaticClose={() => setInfoModalStaticShow(false)}
        infoModalStaicShowType={infoModalStaicShowType}
      />
    </>
  );
}
